var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{
    'flex space-s-0.75': true,
    'font-sans': true,
    'text-dark-text-200': _vm.bgColorScheme === 'light',
    'text-light-text-200': _vm.bgColorScheme === 'dark',
  }},[(_vm.isBuilderRegistered)?_c('a',{class:{
      'text-dark-text-200 hover-hover:hover:text-dark-text-100 hover-hover:focus-visible:text-dark-text-100 focus-ring:light':
        _vm.bgColorScheme === 'light',
      'text-light-text-200 hover-hover:hover:text-light-text-100 hover-hover:focus-visible:text-light-text-100 focus-ring:dark':
        _vm.bgColorScheme === 'dark',
      'hover-hover:hover:underline': true,
    },attrs:{"href":_vm.builderProfileUrl,"target":"_blank"}},[_vm._v("\n    "+_vm._s(_vm.builder.name || _vm.builder.username)+"\n  ")]):_c('span',[_vm._v(_vm._s(_vm.__('Anonymous')))]),_vm._v(" "),(_vm.contributorCount > 0)?[_vm._v("\n     \n    "),_c('OzBaseButton',{staticClass:"leading-[inherit] text-inherit",class:{
        'contributor-list-button': true,
        'bg-transparent p-0 group': true,
        'text-dark-text-200 hover-hover:hover:text-dark-text-100 hover-hover:focus-visible:text-dark-text-100 focus-ring:light':
          _vm.bgColorScheme === 'light',
        'text-light-text-200 hover-hover:hover:text-light-text-100 hover-hover:focus-visible:text-light-text-100 focus-ring:dark':
          _vm.bgColorScheme === 'dark',
      },attrs:{"title":_vm.contributorText,"aria-label":_vm.__('Show contributors list')},on:{"click":_vm.showContributorsList}},[_vm._v("\n      +\n      "),_c('span',{staticClass:"hover-hover:group-hover:underline"},[_vm._v(_vm._s(_vm.contributorCount))])])]:_vm._e(),_vm._v(" "),_c('div',[_c('span',{class:{
        'text-dark-text-300': _vm.bgColorScheme === 'light',
        'text-light-text-300': _vm.bgColorScheme === 'dark',
      }},[_vm._v("\n       •\n    ")]),_vm._v(" "),_c('RelativeTime',{attrs:{"datetime":_vm.wallUpdatedAt}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }